<template>
  <div>
      <el-form label-position="top"
               label-width="145px"
               :model="inServFormz"
               :rules="dataRule"
               ref="inServFormz">
    <el-input type="hidden"
              v-model="inputvalues22"
              ref="inputvalues22input"></el-input>
    <el-row :gutter="11"
            style="height:20px;">
      <el-col :span="7">
<!--        <span>选项:{{inputvalues22}}</span>-->
          <span>必修项</span>
      </el-col>
       <el-col :span="10" >
          <el-col :span="11"><span v-if="inputvaluestrue22 == '20'">选项内的课程在课程开始</span></el-col>
           <el-col :span="6">
             <!-- oninput="getupdata"
             onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" -->
          <el-input  ref="days" @change="getupdata" oninput="getupdata" v-model.number="days" maxlength="9"
             v-if="inputvaluestrue22 == '20'" style="width: 80px; float: left;"></el-input>
          <!-- </el-form-item> -->
            </el-col>
            <el-col :span="6">
              <span style="padding-left: 5.5px; float: left;" v-if="inputvaluestrue22 == '20'">天前完成</span></el-col>
          <!-- </el-form-item> -->
            <span v-if="inputvaluestrue22 == '10'"> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</span>
           </el-col>
      <div style="text-align:right;">
<!--        <el-col :span="7">-->
<!--          &lt;!&ndash; style="margin-left: 200px;" class="filter-item" @click="clickTest" class="el-back M-search M-margin-l" &ndash;&gt;-->
<!--          <el-button type="text"-->
<!--                    @click="addCourse(inputvalues, inputvaluestrue22)">添加</el-button>-->
<!--         <el-button type="text"-->
<!--                     @click="deleteRow(inputindex, inputvaluesfu)">删除</el-button>-->
<!--        </el-col>-->
      </div>
    </el-row>
    <el-dialog
               :modal="true" width="1100px"
               :visible.sync="dialogTableVisible"
               >
      <div style="height: 600px;">
         <courseds @inputss="inputss"
                       ref="selCourseDialog"
                       :courseInfoList="courseInfoList"></courseds>
      </div>
    </el-dialog>
    <div v-show="(inputvalues.length > 0)">
      <el-table ref="tbl"
                :key='tableKey'
                :data="inputvalues"
                v-loading.body="listLoading"
                :show-header="false"
                :cell-style="cellStylec"
                style="width: 100%;text-align: left;"
                border
                stripe
                empty-text=" ">
        <el-table-column label="coursecode"
                         prop="course"
                         min-width="100px"
                         width="300px"
                         align="center">
        </el-table-column>
        <el-table-column label="coursecode"
                         prop="courseConditionStatus"
                         min-width="180px"
                         width="400px"
                         align="center">
          <template slot-scope="scope">
          <!-- <el-form-item :prop="'inputvalues.' + scope.$index + '.courseConditionStatus'" class="rules"  :rules='dataRule.courseConditionStatus'> -->
            <!-- <el-input v-model="scope.row.courseConditionStatus"></el-input> -->
            <el-select v-model="scope.row.courseConditionStatus"
                       @click="selectTrigger(inputvalues,scope.$index,scope.row)"
                       @change="selectTrigger(inputvalues,scope.$index,scope.row)"
                       multiple
                       filterable
                       default-first-option
                       placeholder="">
                <el-option v-for="(item,index) in options"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
            </el-select>
            <!-- </el-form-item> -->
          </template>
        </el-table-column>
        <el-table-column label="coursecode"
                         prop="courseKind"
                         min-width="80px"
                         align="center">
        </el-table-column>
<!--          <el-table-column label="coursecode"-->
<!--                         min-width="180px"-->
<!--                         width="80px"-->
<!--                         align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button type="text"-->
<!--                       @click="deleteRowz(scope.$index, inputvalues)">-->
<!--              删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <!-- 标签 -->
    </el-form>
  </div>
</template>
<script>
// import courseds from '@/views/modules/learning/course/csbase/courseds'
// import courseds from './offeringCourseds'
import courseds from './seloffCourse'

export default {
  components: {
    courseds
  },
  name: 'condition',
  props: {
    // 设置列表文本框是否显示
    days: Number, // String, // 天数
    inputvaluestrue22: String,
    inputvaluesfu: Array, // String, // 父的
    inputvalues: Array, // String, // 父的子内容
    // inputvalues
    inputvalues22: Number, // String, // 父的选项
    inputindex: Number, // String, // 父的index
    sh: {
      type: String,
      default: 'def'
    }
  },
  data () {
    return {
      courseInfoList: [],
      inServFormz: {
        days: ''
        // courseRevokePenaltyList: [{ day: 20, startDays: '20' }]
      },
      infiledList: [],
      input: '',
      dialogTableVisible: false,
      val: 'test',
      courselst: [],
      cnt: 0,
      listLoading: '',
      tableKey: '',
      options: this.enums['blendcourseCondStatu']
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      // // 验证活动名称的函数
      // this.$message('********' + this.$refs.tbl)
      // let validateName = (rule, value, callback) => {
      //   // 当活动名称为空值且为必填时，抛出错误，反之通过校验
      //   if (this.infiledList.courseConditionStatus === []) {
      //     callback(new Error('请输入活动名称'))
      //   } else {
      //     callback()
      //   }
      // }
      return {
        days: [
          // { required: true, validator: validateName, trigger: 'blur' },
          { type: 'number', required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        startDays: [
          // { required: true, validator: validateName, trigger: 'blur' },
          { type: 'number', required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    },
    addCourse (courseInfoList, index) {
      this.optionIndex = index
      // this.$message(courseInfoList + '****' + courseInfoList.length)
      this.courseInfoList = courseInfoList
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.selCourseDialog && this.$refs.selCourseDialog.initMethods()
      })
    },
    getupdata () {
      var days = this.$refs.days.value + ''
      // var days = ''
      // if (daysc.indexOf('.') !== -1) {
      //   days = daysc.replace(new RegExp('.', 'g'), '')
      // } else {
      //   days = daysc
      // }
      // this.$refs.days.value = days
      var nams = this.$refs.inputvalues22input.value
      // if (days === null || days === '') {
      //   this.$message({
      //     showClose: true,
      //     message: '天数不允许为空',
      //     type: 'error',
      //     duration: 5000
      //   })
      // } else {
      //   if (days === '0') {
      //     this.$message({
      //       showClose: true,
      //       message: '天数必须为正整数',
      //       type: 'error',
      //       duration: 5000
      //     })
      //   }
      // }
      // this.$message(days + '***********' + nams)
      // var data = this.inServFormz
      // return data
      this.$emit('blenddayslist', [{ names: nams, days: days }])
    },
    inputss: function (data) {
      var nams = this.$refs.inputvalues22input.value
      data.forEach(row => {
        this.infiledList.push({ id: row.id, course: row.course, courseKind: row.courseKind, courseConditionStatus: ['a1'] })
      })
      // 数据去重
      // this.infiledList = this.unique(this.infiledList)
      this.$emit('blendappenddata', [{ names: nams, data: this.infiledList }])// 'data :传当前的值
      this.infiledList = []
      this.dialogTableVisible = false
    },
    selectTrigger (data, val, row) {
      if (row.courseConditionStatus.length === 0) {
        this.$message({
          showClose: true,
          message: '状态不允许为空',
          type: 'error',
          duration: 5000
        })
      } else {
        var courseConditionStatustrue = '10'
        var indexs = 0
        data.forEach(rows => {
          var courseConditionStatus = rows.courseConditionStatus + ''
          // 处理已完成的 只要出现就显示
          // if (courseConditionStatus.indexOf('30') !== -1 && courseConditionStatus.split(',').length === 1) {
          //   ++indexs
          // }
          if (courseConditionStatus.indexOf('10')>=0) {
             ++indexs
          }
        })
         if(indexs>0){
           courseConditionStatustrue = '20' // 20 为显示
        }
        var nams = this.$refs.inputvalues22input.value
        this.$emit('blendhiddens', [{ names: nams, hiddernames: courseConditionStatustrue + '' }])
      }
    },
    del (idx) {
      // this.courselst.splice(rd)
      this.courselst.splice(idx, 1)
      // alert(idx)
    },
    deleteRowcopy (index, rows) { // 删除改行
      rows.splice(index, 1)
    },
    // 删除
    deleteRow (index, rows) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        rows.splice(index, 1)
        var i = 0
        rows.forEach(row => {
          i = Number(i) + Number(1)
          row.optionIndex = i
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除
    deleteRowz (index, rows) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        rows.splice(index, 1)
        var courseConditionStatustrue = '10'
        var indexs = 0
        rows.forEach(rows => {
          var courseConditionStatus = rows.courseConditionStatus + ''
          // 处理已完成的 只要出现就显示
         if (courseConditionStatus.indexOf('10')>=0) {
             ++indexs
          }
        })
        if(indexs>0){
           courseConditionStatustrue = '20' // 20 为显示
        }
        var nams = this.$refs.inputvalues22input.value
        this.$emit('blendhiddens', [{ names: nams, hiddernames: courseConditionStatustrue + '' }])
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.el-table .cell {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: normal;
    word-break: break-all;
    line-height: 1px;
}
.el-input {
    position: relative;
    font-size: 14px;
    display: inline;
    /* display: inline-block; inline*/
    width: 100%;
}
.div-inline {
  display: inline;
}
.left {
  /*display:inline;*/
  width: 200px;
  /*float:left;*/

  background: red;
}
.right {
  overflow: hidden;

  background: blue;
}
.container {
  width: 100%;
  height: 100%;
}
.left1 {
  float: left;
  width: 200px;
  height: 100%;
  /*background: #ffcafd;*/
}
.right1 {
  height: 100%;
  width: auto;
  margin-left: 200px;
  background: #e3e3e3;
}

.el-table .td {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.el-table .th {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
